import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';


// Configure Contentful Client
const contentful = require('contentful')
const client = contentful.createClient({
  space: process.env.REACT_APP_CSPACE,
  accessToken: process.env.REACT_APP_CTOKEN
})

const Body=({entryId})=> {
  const [entry, setEntry] = useState(null);

  // PULL DYNAMICALLY FROM CONTENTFUL
  useEffect(() => {
    retrieveEntry();
  }, [entryId]);

  function retrieveEntry() {
    client.getEntry(entryId)
    .then((res) => {
      console.log(res);
      setEntry(res)
    })
    .catch(console.error)
  }

  // show a loading screen case the data hasn't arrived yet
  if (!entry) {
    return (
      <button className="btn btn-white" type="button" disabled>
      <span className="sr-only p-3">Select an element on the Radar...</span>
      <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      </button>
    )
  }

  const rawRichTextField = entry.fields.content || '';
  const richText = documentToReactComponents(rawRichTextField);

  return (
    <>
      <h1 id="entry">{entry.fields.title}</h1>
      {richText}
    </>
  )


}

export default Body;
